export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.ce475cfb.ttf";